<div class="product-card mfp-white-box" [ngClass]="{ 'product-card--selected': active == product.id }">
  <div class="product-card__header">
    <div class="product-card__header-content">
      <mfp-radio-button
        view="agent"
        name="product"
        [labelSize]="'large'"
        [label]="product.labels.name"
        [idRadio]="product.id"
        [valueRadio]="product.id"
        [disabled]="lifePlan.status === 'SENT'"
        [ngModel]="active"
        (ngModelChange)="onChangeActive()"
      ></mfp-radio-button>
    </div>
  </div>

  <div class="product-card__body">
    <div class="product-card__price">
      <div
        class="product-card__price-row"
        [ngClass]="{ 'product-card__price-row--reverse': currencyPosition === 'left' }"
      >
        <h1 class="product-card__price-title">{{ getAmount() | configCurrency }}</h1>
        <mfp-select-currency
          [disabled]="active !== product.id || lifePlan.status === 'SENT'"
          [options]="allowedCurrencies"
          [ngModel]="product.selectedCurrency"
          (ngModelChange)="onCurrencyChange($event)"
        ></mfp-select-currency>
      </div>
      <p class="product-card__price-subtitle">{{ '' }}</p>
    </div>

    <div class="product-card__retirement">
      <mfp-select
        view="agent"
        color="primary"
        [options]="options"
        [disabled]="active !== product.id || lifePlan.status === 'SENT'"
        [error]="!product.selectedTemporality && active === product.id"
        [helper]="
          !product.selectedTemporality && active === product.id ? ('PRODUCT_SELECT.MANDATORY_FIELD' | translate) : ''
        "
        [ngModel]="product.selectedTemporality"
        (ngModelChange)="onTemporalityChange($event)"
      ></mfp-select>
      <ng-container *ngIf="product.allowedIncreases && product.allowedIncreases.length > 0">
        <div class="product-card__increase">
          <mfp-select
            view="agent"
            color="primary"
            [options]="increaseOptions"
            [disabled]="active !== product.id || lifePlan.status === 'SENT'"
            [error]="!product.selectedIncrease && active === product.id"
            [helper]="
              !product.selectedIncrease && active === product.id ? ('PRODUCT_SELECT.MANDATORY_FIELD' | translate) : ''
            "
            [ngModel]="product.selectedIncrease?.percentage"
            (ngModelChange)="onIncreaseChange($event)"
          ></mfp-select>
        </div>
      </ng-container>
    </div>

    <ng-content></ng-content>
  </div>
</div>
